import { Service, inject } from '@angular/core';
import { FilterTypeEnum } from 'app/back-office/shared/enum/filter-type.enum.model';
import { ActiveChannelDTO } from 'app/shared/models/channel.model';
import { FilterTask, FilterTaskResponse } from 'app/shared/models/filter-group.models';
import { HttpBasicRequest } from 'app/shared/models/http-basic-request.model';
import { BasicHttpClientService } from 'app/shared/services/basic-http-client.service';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Service()
export class SearchBarService {
  private _httpClient = inject(BasicHttpClientService);

  private baseUrl: string;
  private _shopContext = inject(ShopContextStore);

  private currentChannelFilter = new BehaviorSubject<ActiveChannelDTO>(null);
  currentChannelFilter$ = this.currentChannelFilter.asObservable();
  currentChannelFilterValue = this.currentChannelFilter.value;

  constructor() {
    this.baseUrl = environment.urls.apiUrl.url;
  }

  setCurrentChannelFilter(id: number) {
    if (id) {
      this.currentChannelFilter.next(this._shopContext.getChannelById(id));
    } else {
      this.currentChannelFilter.next(null);
    }
  }

  getFilterRootSelected(FilterTask: FilterTask[]) {
    const request: HttpBasicRequest[] = [];
    FilterTask.forEach(element => {
      switch (element.type) {
        case FilterTypeEnum.agencyFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/agencies/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.customerFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/customers/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.ordersFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/orders/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.seasonReferenceFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/season-references/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.showcasesFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/showcases/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.voucherFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/vouchers/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.posFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/point-of-sales/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.assortmentFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/assortments/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.styleGroupFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/style-group/${id}`,
              method: 'get'
            }));
          });
          break;
        case FilterTypeEnum.customerGroupCodeFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/general-fields/${id}`,
              method: 'get'
            }));
          });
          break;

        case FilterTypeEnum.customerSubgroupCodeFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/general-fields/${id}`,
              method: 'get'
            }));
          });
          break;

        case FilterTypeEnum.customerHoldingFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/general-fields/${id}`,
              method: 'get'
            }));
          });
          break;

        case FilterTypeEnum.customerSignBoardFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/general-fields/${id}`,
              method: 'get'
            }));
          });
          break;

        case FilterTypeEnum.customerGroupFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/general-fields/${id}`,
              method: 'get'
            }));
          });
          break;

        case FilterTypeEnum.salesTaxGroupFilter:
          element.ids.forEach(id => {
            request.push(new HttpBasicRequest({
              url: `${this.baseUrl}/general-fields/${id}`,
              method: 'get'
            }));
          });
          break;

        default:
          break;
      }
    });

    return this._httpClient.forkJoin<FilterTaskResponse[]>(request).pipe(
      map((response: []) => {
        const result: any[] = [];
        let elementAnalized: number = 0;
        FilterTask.forEach(element => {
          const filterTaskResponse: FilterTaskResponse = new FilterTaskResponse({
            ...element,
            response: [],
          });

          element.ids.forEach(id => {
            response.forEach(element => {
              filterTaskResponse.response.push(element);
            });
            elementAnalized++;
            result.push(filterTaskResponse);
          });
        });
        return result;
      })
    );
  }
}
